import { CPR_AUTH, CPR_BROWSERID, FAF_AUTH, FAF_BROWSERID } from "../../constant/Constants";
import axiosCall from "../axiosCall";
import { resetSessionTiming } from "../sessionManagement";

export const claimListService = async ({ appID, ein, prgData }) => {
    resetSessionTiming()
    const params = appID ? `ApplicationID=${appID}&ProviderID=E-${ein}` : `ProviderID=E-${ein}`
    const authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    const response = await axiosCall('get', `/v1/data/D_ExternalClaimsList?`, authorization, params, null, prgData);
    return { res: response.data.pxResults, program: prgData }
}

export const claimProcess = async ({ appID, prgData }) => {
    resetSessionTiming()
    const authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    const response = await axiosCall('get', `/v1/data/D_ProcessApplication?`, authorization, `pyID=${appID}`, null, prgData);
    return { res: response.data, prg: prgData }
}

export const claimSubmission = async ({ prgData, reqBody }) => {
    resetSessionTiming()
    const authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    let browserID = prgData == 'CPR' ? CPR_BROWSERID : FAF_BROWSERID;
    const response = await axiosCall('post', `/Claims/v1/Claims/Patient/${prgData}?`, authorization, `BrowserID=${browserID}`, reqBody, prgData);
    return response.data
}
